import React from 'react';

import styles from './troy.module.scss';

import Welcome from '.';

const header = 'Herzlich Willkommen!';
const content = (
  <>
    Wir sind Deine Helfer in Sachen Inkasso!
    <br />
    Zusammen klären wir schnell und
    <br />
    unkompliziert alle Forderungen.
  </>
);

const TroyWelcome = () => <Welcome {...{ styles, header, content }} />;

TroyWelcome.propTypes = {};

export default TroyWelcome;
